import React from 'react';
import {
  Alert,
  Badge,
  Button,
  Col,
  Modal,
  Row,
} from 'react-bootstrap';
import Loading from '~/Components/Loading';

export default function ModalDetalheAtivo(props) {
  var show = props.show;
  var onHide = props.onHide;
  var detalheInfo = props.detalheInfo;
  var detalheAtivo = props.detalheAtivo;
  var isLoadingDetalhe = props.isLoadingDetalhe;
  var formatarData = props.formatarData;
  var formatarDataCurta = props.formatarDataCurta;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="xl"
    >
      <Modal.Header closeButton className="bg-primary text-white">
        <Modal.Title>
          {detalheInfo &&
            (detalheInfo.empreendimento + ' - Ativo: ' + detalheInfo.codigo_ativo + ' - QD: ' + detalheInfo.quadra + ' / LT: ' + detalheInfo.lote)}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoadingDetalhe && (
          <div className="text-center my-4">
            <Loading />
          </div>
        )}

        {!isLoadingDetalhe && detalheAtivo && (
          <>
            <h6 className="mt-2 mb-2">
              <strong>Histórico de Reservas do Lote</strong>
            </h6>
            {detalheAtivo.reservas && detalheAtivo.reservas.length > 0 ? (
              <div className="table-responsive mb-4">
                <table className="table table-bordered table-sm table-hover">
                  <thead className="thead-light">
                    <tr className="text-center">
                      <th>Corretor</th>
                      <th>Status</th>
                      <th>Reservado em</th>
                      <th>Validade</th>
                      <th>Cancelado em</th>
                      <th>Cancelado por</th>
                      <th>Pré-venda</th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {detalheAtivo.reservas.map(function (r, i) {
                      return (
                        <tr
                          key={'res-' + i}
                          style={{
                            backgroundColor:
                              r.pre_venda > 0 ? '#dff0d8' : undefined,
                          }}
                        >
                          <td className="text-left">{r.corretor || '-'}</td>
                          <td>{r.status || '-'}</td>
                          <td>{formatarDataCurta(r.reserva)}</td>
                          <td>{formatarDataCurta(r.validade)}</td>
                          <td>{formatarDataCurta(r.data_cancelamento)}</td>
                          <td>{r.usuario_cancelamento || '-'}</td>
                          <td>{r.pre_venda || '-'}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <Alert variant="info" className="mb-4">
                Não há histórico de reservas para esse ativo.
              </Alert>
            )}

            <Row>
              <Col md={5}>
                <h6 className="mb-2">
                  <strong>Fila atual ativa do lote</strong>
                </h6>
                {detalheAtivo.fila_atual &&
                  detalheAtivo.fila_atual.length > 0 ? (
                  <div className="table-responsive mb-3">
                    <table className="table table-bordered table-sm table-hover">
                      <thead className="thead-light">
                        <tr className="text-center">
                          <th>Corretor</th>
                          <th>Imobiliária</th>
                          <th>Entrada</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {detalheAtivo.fila_atual.map(function (f, i) {
                          return (
                            <tr key={'fila-' + i}>
                              <td className="text-left">{f.corretor || '-'}</td>
                              <td>{f.imobiliaria || '-'}</td>
                              <td>{formatarData(f.entrada)}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <Alert variant="info" className="mb-3">
                    Não há fila ativa para esse ativo.
                  </Alert>
                )}
              </Col>

              <Col md={7}>
                <h6 className="mb-2">
                  <strong>Histórico da fila do lote</strong>
                </h6>
                {detalheAtivo.historico_fila &&
                  detalheAtivo.historico_fila.length > 0 ? (
                  <div className="table-responsive mb-3">
                    <table className="table table-bordered table-sm table-hover">
                      <thead className="thead-light">
                        <tr className="text-center">
                          <th>Operador</th>
                          <th>Corretor</th>
                          <th>Movimentação</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {detalheAtivo.historico_fila.map(function (h, i) {
                          return (
                            <tr
                              key={'hist-' + i}
                              style={{
                                backgroundColor:
                                  h.status === 'Entrou'
                                    ? '#dff0d8'
                                    : h.status === 'Saiu'
                                      ? '#f2dede'
                                      : undefined,
                              }}
                            >
                              <td>{h.nome_operador || '-'}</td>
                              <td>{h.nome_corretor || '-'}</td>
                              <td>{formatarData(h.movimentacao)}</td>
                              <td>
                                <Badge
                                  variant={
                                    h.status === 'Entrou' ? 'success' : 'danger'
                                  }
                                >
                                  {h.status}
                                </Badge>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <Alert variant="info" className="mb-3">
                    Não há histórico de fila para esse ativo.
                  </Alert>
                )}
              </Col>
            </Row>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
